import Vue from 'vue'
import VueRouter from 'vue-router'
import AboutView from '../views/AboutView.vue'
import RouterView from "../views/RouterView.vue";

import { i18n } from "../main.js";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'About',
    component: AboutView
  },
  {
    path: 'description',
    name: 'Description',
    component: () => import('../views/DescriptionView.vue')
  },
  {
    path: 'team',
    name: 'Team',
    component: () => import('../views/TeamView.vue')
  },
  {
    path: 'activities',
    name: 'Activities',
    component: () => import('../views/ActivitiesView.vue')
  },
  {
    path: 'publications',
    name: 'Publications',
    component: () => import('../views/PublicationsView.vue')
  },
  {
    path: 'contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: 'links',
    name: 'Links',
    component: () => import('../views/LinksView.vue')
  },
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/:lang",
      component: RouterView,
      beforeEnter(to, from, next) {
        const lang = to.params.lang;
        if (!["pt", "en"].includes(lang)) return next("en");
        if (i18n.locale !== lang) {
          i18n.locale = lang;
        }
        return next();
      },
      children: routes
    },
    {
      path: "*",
      redirect: "/en/"
    }
  ]
});
export default router
